export interface DocumentTemplate {
  template: {
    id: string;
    name: string;
    description: string;
  };
}

export interface MilesDocumentTemplatesResponse {
  financialProduct: {
    offers: {
      offerId: string;
      documents: DocumentTemplate[];
    }[];
  };
}

export enum MilesDurationUnit {
  MONTHS = 'MONTHS',
}

export enum MilesIdentifierSourceType {
  CAMPAIGN_ID = 'CAMPAIGNID',
  JATO = 'JATO',
  MILES_CATALOG_VEHICLE_ID = 'MILES_CATALOG_VEHICLE_ID',
  MILES_MODEL_ID = 'MILES_MODEL_ID',
  MILES_CUSTOMER_ID = 'MILES_CUSTOMER_ID',
}

export enum MilesCustomerIdentifierSourceType {
  MILES_CUSTOMER_ID = 'MILES_CUSTOMER_ID',
  MILES_CUSTOMER_APPLICANT_CREDIT_ID = 'MILES_CUSTOMER_APPLICANT_CREDIT_ID',
  MILES_PERSON_ID = 'MILES_PERSON_ID',
}

export interface MilesCustomerExternalIdentifier {
  id: string;
  type: MilesCustomerIdentifierSourceType;
}

export interface MilesQuoteResponse {
  financialProduct?: {
    offers?: {
      calculation?: {
        grossLoanAmount?: {
          grossAmount?: number;
          netAmount?: number;
        };
        includingRegistration?: number;
        registrationDepartment?: number;
        commercialVehicleTransform?: number;
        eligibility?: number;
        duration?: number;
        contractMileage?: number;
        subsequentInstallmentAmount?: {
          amount?: number;
        };
      };
      offerId?: string;
      offerReference?: string;
      statusId?: string;
      offreplus?: boolean;
      createdAt?: boolean;
      milesTemplateId?: string;
      productName?: string;
      duration?: number;
      contractMileage?: number;
      durationUnit?: MilesDurationUnit;
      contractCreationDate?: string;
      previousContractId?: string;
      carToRestitute?: boolean;
      subsequentInstallmentTotalAmount?: {
        amount?: number;
      };
      validityEndDate?: string;
      additionalProducts?: {
        name?: string;
        choices?: {
          id?: string;
          name?: string;
          isSelected?: boolean;
          choiceCostAmount?: {
            amount?: number;
            grossNetDifferenceAmount?: number;
          };
        }[];
      }[];
    }[];
  };
  vehicleData?: {
    retailPriceAmount?: {
      grossAmount?: number;
      netAmount?: number;
      currency?: string;
    };
    batteryPrice?: {
      amount?: number;
    };
    fiscalPower?: number;
    model?: {
      name?: string;
      manufacturer?: QuoteSchema.Schemas.ManufacturerType | undefined;
      description?: string;
      options?: {
        prKey?: string;
        isSelected?: boolean;
      }[];
    };
    externalVehicleIdentifiers: {
      id?: string;
      type?: MilesIdentifierSourceType;
    }[];
  };
  customerData?: {
    tradingName?: string;
    externalIdentifiers?: MilesCustomerExternalIdentifier[];
    customerType?: string;
    companyData?: {
      companyRegistrationNumber?: string;
      role?: {
        type?: string;
      };
      entityLegalForm?: string;
      name?: string;
    };
  };
}

export type GetQuotesResponse = {
  currentPage: number;
  totalPages: number;
  totalCount: number;
  pageSize: number;
  quotes: QuoteSchema.Schemas.QuoteResponse[];
};
